import React, { Component } from "react";
import {
  Breadcrumb,
  Form,
  Button,
  InputNumber,
  Radio,
  Select,
  Divider,
  message,
} from "antd";
import "./InitialCalculation.scss";
import momenthijri from "moment-hijri";
import "react-phone-number-input/style.css";
import DatePicker from "react-multi-date-picker";
import arabic from "react-date-object/calendars/arabic";
import arabic_ar from "react-date-object/locales/arabic_ar";
import { Link, withRouter } from "react-router-dom";
import { HomeOutlined } from "@ant-design/icons";
import {
  FaAngleLeft,
} from "react-icons/fa";
import LandingHeader from "../../components/LandingHeader/LandingHeader";
import LandingFooter from "../../components/LandingFooter/LandingFooter";
import { connect } from "react-redux";
import { CalculateFinancingRequestAccounting } from "../../network/request.network";

const { Option } = Select;
const provinceData = ["Zhejiang", "Jiangsu"];
const cityData = {
  Zhejiang: ["Hangzhou", "Ningbo", "Wenzhou"],
  Jiangsu: ["Nanjing", "Suzhou", "Zhenjiang"],
};



class InitialCalculation extends Component {
  state = {
    step: 1,
    FinancingRequestTypeId: 2,
    showResults: false,
    numberVal: "",
    JobTitlesState : [],
    jobTitle:null,
    isSocial:null,
    checkJobTitle:false,
    IsSupport:1,
    btnloading: false,
    // calcData: {},
    provinceData: ["عسكري", "Jiangsu"],
    cityData: {
      عسكري: ["رقيب", "ملازم", "عقيد"],
      Jiangsu: ["Nanjing", "Suzhou", "Zhenjiang"],
    },
  };

  componentDidMount() {
    const authResult = new URLSearchParams(window.location.search); 
    const isSocial = authResult.get('Social');
    console.log(isSocial)
    this.setState({isSocial})
   }

  handleProvinceChange = (value) => {
    this.setState({ activeList: value });
  };

  handleEmployerChange = (value) => {
    const JobTitlesState = this.props?.JobTitles.filter(title => title.EmployerId === value);
    this.setState({JobTitlesState, jobTitle : null, employerTitle : value});
    if(value === null) this.setState({checkJobTitle:true});
    else this.setState({checkJobTitle:false});
  };

  onTitleChange = (value) => {
    this.setState({jobTitle : value});
  };

  onSecondCityChange = (value) => {
    console.log(value);
  };

  onFinish = (values) => {
    if(!values.IsSupport) values.IsSupport = this.state.IsSupport;
    if(this.state.employerTitle === null) this.setState({checkJobTitle:true});
    else this.setState({checkJobTitle:false});
      this.setState({ btnloading: true });

    let body = {
      FinancingRequestTypeId: values.FinancingRequestTypeId,
      IsSupported: values.IsSupport? true:false,
      Salary: values.Salary,
      JobTitleId: this.state.jobTitle,
      BirthDate:momenthijri(values.BirthDate?.toDate?.().toString()).format("YYYY-MM-DD"),
      FinancingAmount: values.FinancingAmount,
      MonthsCount: values.MonthsCount,
      EmployerId: this.state.employerTitle,
      // Page: 0,
    }

    CalculateFinancingRequestAccounting(
      body,
      (res) => {
        message.success("تم إرسال الحسبة بنجاح")
        this.setState({ 
          btnloading: false,
          calcData: res.data.model,
          showResults: true
        });

      },
      (err) => {
        this.setState({ btnloading: false })
        message.error("حدث خطأ ما حاول مرة أخرى");      
      }
    )
  }

  render() {
    const { employerTitle, jobTitle, JobTitlesState, calcData, btnloading, showResults, isSocial} = this.state;

    return (
      <div className="page-landing-wrapper">
      <LandingHeader/>
      <div className="client-info-page calculate-register-wrapper">
      <div className="header-img-holder">
          <div className="container">
            <div className="client-header">
              <div className="client-header-first">
                <Breadcrumb separator=">">
                  <Breadcrumb.Item>
                    <a href="https://vga.f4a.myftpupload.com/">
                      <HomeOutlined />
                      <p className="link-name">الرئيسية</p>
                    </a>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>
                    <a href="https://vga.f4a.myftpupload.com/%d8%ae%d8%af%d9%85%d8%a7%d8%aa%d9%86%d8%a7/">
                      <p className="link-name">خدماتنا</p>
                    </a>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item className="last-bread">
                    احسب تمويلك العقاري  
                  </Breadcrumb.Item>
                </Breadcrumb>
                <h1>احسب تمويلك العقاري</h1>
              </div>
            </div>
          </div>
        </div>

        <div className="client-content">
          <div className="container">

            <div className="new-order-form">
              <div className="client-header">
                <h2 className="header-title"> من فضلك ادخل الخيارات المناسبه لك</h2>
              </div>
                <Form
                  id="calc-form"
                  className="add__record--form "
                  layout="vertical"
                  name="nest-messages"
                  onFinish={this.onFinish}
                >
                  <div className="form-content">

                    <Form.Item
                      label="نوع التمويل"
                      name="FinancingRequestTypeId"
                      className="input-holder"
                      rules={[
                          {
                            required: true,
                            message: 'من فضلك ادخل نوع التمويل',
                          },
                        ]}
                    >
                      <Select
                        // onChange={e => this.setState({ FinancingRequestTypeId:e.target.value })} defaultValue={2}
                        >
                        <Select.Option value={2}>عقاري</Select.Option>
                        <Select.Option value={1}>شخصي</Select.Option>
                      </Select>
                    </Form.Item>

                    <Form.Item
                      label="مبلغ التمويل"
                      name="FinancingAmount"
                      className="input-holder"
                      rules={[
                          {
                            required: true,
                            message: 'من فضلك ادخل مبلغ التمويل',
                          },
                        ]}
                    >
                      <InputNumber min={0}/>
                    </Form.Item>

                    <div>
                      <Form.Item
                        label=" جهة العمل"
                        name="customerWork"
                        className="input-holder select-group-holder"
                        style={{marginBottom:"0px"}}
                      >
                        <Select
                          value={employerTitle} 
                          onChange={this.handleEmployerChange}
                        >
                          {this.props.Employers?.map((emp)=>{
                            return(<Select.Option key={emp.Id} value={emp.Id}>{emp.NameLT}</Select.Option>)
                          })}
                        </Select>
                        <Divider style={{ height: 30 }} type="vertical" />
                        <Select
                          value={jobTitle}
                          onChange={this.onTitleChange}
                          disabled={employerTitle==2}
                          placeholder='الرتبه'
                        >
                          {JobTitlesState?.map((title)=>{
                            return(<Select.Option key={title.Id} value={title.Id}>{title.NameLT}</Select.Option>)
                          })}
                        </Select>
                      </Form.Item>
                      {this.state.checkJobTitle && <span style={{color:"#fe5252", textAlign:"right", marginTop:"-10px"}}>من فضلك حدد جهة العمل</span>}
                    </div>

                    <Form.Item
                      label="مدة السداد بالاشهر"
                      name="MonthsCount"
                      className="input-holder"
                      rules={[
                          {
                            required: true,
                            message: 'من فضلك ادخل مدة السداد',
                          },
                        ]}
                    >
                      <InputNumber min={0} />
                    </Form.Item>

                    <Form.Item
                      label="الراتب الاساسي"
                      name="Salary"
                      className="input-holder"
                      rules={[
                          {
                            required: true,
                            message: 'من فضلك ادخل الراتب ',
                          },
                        ]}
                    >
                      <InputNumber min={0} />
                    </Form.Item>

                    <Form.Item
                      label="تاريخ الميلاد"
                      name="BirthDate"
                      className="input-holder"
                      rules={[
                          {
                            required: true,
                            message:'من فضلك ادخل تاريخ الميلاد',
                          },
                        ]}
                    >
                      <DatePicker 
                        maxDate={new Date().setFullYear(new Date().getFullYear() - 1, 0, 1)} 
                        calendar={arabic} locale={arabic_ar} />
                    </Form.Item>

                    <Form.Item
                      label="مدعوم"
                      name="IsSupported"
                      className="input-holder"
                    >
                      <Radio.Group name="radiogroup" onChange={e=>this.setState({IsSupport:e.target.value})} defaultValue={1}>
                        <Radio value={1}>نعم</Radio>
                        <Radio value={2}>لا</Radio>
                      </Radio.Group>
                    </Form.Item>

                  </div>

                  <div className="button-left">
                    <Button htmlType="submit" form="calc-form" type="primary" size="large" className="blue-btn left" loading={btnloading}>
                      اظهار الحسبه
                    </Button>
                  </div>

                </Form>
            </div>


            { showResults &&
            <>
              {calcData?.map((calc, idx) => {
                if(idx === 0)
                return(
                <div key={calc.Id}>
                  <div className="new-order-form" style={{ marginTop : '40px' , marginBottom: '20px' }}>
                    <header className="client-header">
                      <h2 className="header-title">بيانات الحسبه</h2>
                    </header>

                    <div className="info-grid">

                      <div className="info-grid-cell">
                        <p className="info-cell-p">الربح</p>
                        <h6 className="info-cell-val">%{calc?.AccountingRatioValue}</h6>
                      </div>

                      <div className="info-grid-cell">
                        <p className="info-cell-p">مبلغ التمويل</p>
                        <h6 className="info-cell-val">{calc?.FinancingAmout} <span>ر.س</span> </h6>
                      </div>

                      <div className="info-grid-cell">
                        <p className="info-cell-p">قسط الدعم</p>
                        <h6 className="info-cell-val">{calc?.SupportInstallment} <span>ر.س</span> </h6>
                      </div>

                      <div className="info-grid-cell">
                        <p className="info-cell-p">القسط الشهري</p>
                        <h6 className="info-cell-val">{calc?.MonthlyInstallment} <span>ر.س</span></h6>
                      </div>
                    </div>

                    <div className="button-left">
                      {/* <Link to={`/new-order`}> */}
                      <Link to={`/new-order${isSocial ? "?Social=123" : ""}`}>
                        <Button type="primary" size="large" className="get-finance-btn" htmlType="submit">
                        احصل على تمويلك الآن
                        <FaAngleLeft />
                        </Button>
                      </Link>
                    </div>

                    <p className="result result-p-hodler" style={{ color: '#cc3524' }}>
                      ملاحظة: المبالغ المعروضة أعلاه تقريبية حيث أن مبلغ التمويل النهائي يتم احتسابه بناء على التزامات العميل القائمة و معلومات الدخل الشهري عند التقدم بطلب التمويل
                    </p>

                  </div>
                </div>
                )
              })}
            </>
            }


          </div>
        </div>
      </div>
      <LandingFooter />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentLang : state.user.currentLang,
  Cities : state.user.metaData?.Cities,   
  Banks : state.user.metaData?.Banks, 
  Genders : state.user.metaData?.Genders,  
  Employers : state.user.metaData?.Employers, 
  JobTitles : state.user.metaData?.JobTitles || [],
}) 

const InitialCalculationWithRouter = withRouter(InitialCalculation);
export default connect(mapStateToProps)(InitialCalculationWithRouter);